import type { ItemAgenda, DiaAgenda, MesAgenda, FiltroAgenda } from './types';

function chaveDia(d: Date): string {
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

function chaveMes(d: Date): string {
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  return `${ano}-${mes}`;
}

export function formatarDiaCompleto(d: Date): string {
  const semana = d.toLocaleDateString('pt-BR', { weekday: 'long' }).toUpperCase();
  const dia = d.toLocaleDateString('pt-BR', { day: '2-digit' });
  const mes = d.toLocaleDateString('pt-BR', { month: 'long' }).toUpperCase();
  return `${semana}, ${dia} DE ${mes}`;
}

export function formatarHora(d: Date): string {
  return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

export function nomeMes(d: Date): string {
  return d.toLocaleDateString('pt-BR', { month: 'long' });
}

export function formatarMesAno(d: Date): string {
  return `${nomeMes(d)} ${d.getFullYear()}`;
}

export function mesmoMes(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}

export function filtrarItens(itens: ItemAgenda[], filtro: FiltroAgenda): ItemAgenda[] {
  if (filtro === 'tudo') return itens;
  return itens.filter((item) => {
    switch (filtro) {
      case 'eventos':
        return item.o_que === 'evento';
      case 'acampamentos':
        return item.tipo === 'acampamento';
      case 'formacoes':
        return item.tipo === 'formacao';
      case 'missas':
        return item.tipo === 'missa';
      default:
        return true;
    }
  });
}

export function agruparPorDia(itens: ItemAgenda[]): DiaAgenda[] {
  const ordenados = [...itens].sort(
    (a, b) => new Date(a.inicio_em).getTime() - new Date(b.inicio_em).getTime(),
  );
  const mapa = new Map<string, DiaAgenda>();
  ordenados.forEach((item) => {
    const d = new Date(item.inicio_em);
    const chave = chaveDia(d);
    if (!mapa.has(chave)) mapa.set(chave, { chave, data: d, itens: [] });
    mapa.get(chave)!.itens.push(item);
  });
  return [...mapa.values()];
}

export function agruparPorMes(dias: DiaAgenda[]): MesAgenda[] {
  const mapa = new Map<string, MesAgenda>();
  dias.forEach((dia) => {
    const chave = chaveMes(dia.data);
    if (!mapa.has(chave)) {
      const data = new Date(dia.data.getFullYear(), dia.data.getMonth(), 1);
      mapa.set(chave, { chave, data, dias: [] });
    }
    mapa.get(chave)!.dias.push(dia);
  });
  return [...mapa.values()];
}

export function contarPorMes(
  itens: ItemAgenda[],
  ano: number,
): { mes: number; total: number }[] {
  const contagem = new Array(12).fill(0) as number[];
  itens.forEach((item) => {
    const d = new Date(item.inicio_em);
    if (d.getFullYear() === ano) contagem[d.getMonth()] += 1;
  });
  return contagem.map((total, mes) => ({ mes, total }));
}